var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1080 1080",
    style: {
      enableBackground: "new 0 0 1080 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t\t.st0 {\n\t\t\tenable-background: new;\n\t\t}\n\n\t\t.st1 {\n\t\t\tfill: #263135;\n\t\t}\n\n\t\t.st2 {\n\t\t\tfill: #354449;\n\t\t}\n\n\t\t.st3 {\n\t\t\tfill: #41545B;\n\t\t}\n\n\t\t.st4 {\n\t\t\tfill: #202A30;\n\t\t}\n\n\t\t.st5 {\n\t\t\tfill: #2C3B42;\n\t\t}\n\n\t\t.st6 {\n\t\t\tfill: #364852;\n\t\t}\n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Subtraction_11"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "861.68,784.02 759.11,728.22 759.26,648.49 861.83,704.29  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "787.81,794.4 685.24,738.61 759.11,728.22 861.68,784.02  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "861.98,624.55 759.41,568.75 759.56,489.02 862.13,544.82  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "788.11,634.93 685.54,579.13 759.41,568.75 861.98,624.55  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "714.83,804.66 612.26,748.86 612.41,669.13 714.98,724.93  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "640.96,815.04 538.39,759.25 612.26,748.86 714.83,804.66  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "862.28,465.08 759.71,409.29 759.86,329.55 862.42,385.35  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "788.4,475.47 685.83,419.67 759.71,409.29 862.28,465.08  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "715.12,645.19 612.55,589.39 612.7,509.66 715.27,565.46  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "641.25,655.57 538.68,599.77 612.55,589.39 715.12,645.19  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "862.57,305.61 760,249.81 760.15,170.08 862.72,225.88  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "788.7,315.99 686.13,260.19 760,249.81 862.57,305.61  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "715.42,485.72 612.85,429.93 613,350.19 715.57,405.99  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "641.55,496.11 538.98,440.31 612.85,429.93 715.42,485.72  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "715.72,326.25 613.15,270.45 613.3,190.72 715.87,246.52  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "641.84,336.63 539.28,280.83 613.15,270.45 715.72,326.25  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "568.27,187.55 465.7,131.75 835.07,79.84 937.64,135.64  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "566.94,905.16 464.37,849.36 465.7,131.75 568.27,187.55  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M568.27,187.55l369.37-51.91l-1.33,717.61l-369.37,51.91L568.27,187.55z M715.72,326.25l0.15-79.73 l-73.87,10.38l-0.15,79.73L715.72,326.25 M715.42,485.72l0.15-79.73l-73.87,10.38l-0.15,79.73L715.42,485.72 M862.57,305.61 l0.15-79.73l-73.87,10.38l-0.15,79.73L862.57,305.61 M715.12,645.19l0.15-79.73l-73.87,10.38l-0.15,79.73L715.12,645.19  M714.83,804.66l0.15-79.73l-73.87,10.38l-0.15,79.73L714.83,804.66 M862.28,465.08l0.15-79.73l-73.87,10.38l-0.15,79.73 L862.28,465.08 M861.68,784.02l0.15-79.73l-73.87,10.38l-0.15,79.73L861.68,784.02 M861.98,624.55l0.15-79.73l-73.87,10.38 l-0.15,79.73L861.98,624.55"
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Subtraction_12"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "497.79,835.23 395.22,779.44 395.37,699.7 497.94,755.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "423.91,845.62 321.34,789.82 395.22,779.44 497.79,835.23  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "498.09,675.77 395.52,619.97 395.67,540.24 498.24,596.04  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "424.21,686.15 321.64,630.36 395.52,619.97 498.09,675.77  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "358.94,854.75 256.37,798.95 256.52,719.22 359.09,775.02  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "285.07,865.13 182.5,809.33 256.37,798.95 358.94,854.75  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "498.38,516.3 395.81,460.5 395.96,380.77 498.53,436.56  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "424.5,526.68 321.93,470.88 395.81,460.5 498.38,516.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "359.24,695.28 256.67,639.49 256.81,559.75 359.38,615.55  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "285.36,705.67 182.79,649.87 256.67,639.49 359.24,695.28  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "359.53,535.81 256.96,480.01 257.11,400.28 359.68,456.08  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "285.66,546.19 183.09,490.39 256.96,480.01 359.53,535.81  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "215.49,954.67 112.92,898.87 113.96,340.74 216.53,396.54  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "216.53,396.54 113.96,340.74 465.53,291.33 568.1,347.13  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M216.53,396.54l351.57-49.41l-1.04,558.13l-351.57,49.41L216.53,396.54z M497.79,835.23l0.15-79.73 l-73.88,10.38l-0.15,79.73L497.79,835.23 M498.09,675.77l0.15-79.73l-73.88,10.38l-0.15,79.73L498.09,675.77 M498.38,516.3 l0.15-79.73l-73.88,10.38l-0.15,79.73L498.38,516.3 M358.94,854.75l0.15-79.73l-73.87,10.38l-0.15,79.73L358.94,854.75  M359.24,695.28l0.15-79.73l-73.87,10.38l-0.15,79.73L359.24,695.28 M359.53,535.81l0.15-79.73l-73.87,10.38l-0.15,79.73 L359.53,535.81"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrg);
export default __webpack_public_path__ + "static/media/org.07945b9197d6e5e80b9fb7e165c9ccb0.svg";
export { ForwardRef as ReactComponent };